export const Manager_DiseaseProfile_ProfileTab_General = 'general';
export const Manager_DiseaseProfile_ProfileTab_Scores = 'scores';
export const Manager_DiseaseProfile_ProfileTab_Epidemiology = 'epidemiology';
export const Manager_DiseaseProfile_ProfileTab_Prognosis = 'prognosis';
export const Manager_DiseaseProfile_ProfileTab_References = 'references';
const Manager_DiseaseProfile_ProfileTabs = [Manager_DiseaseProfile_ProfileTab_General,
    Manager_DiseaseProfile_ProfileTab_Scores,
    Manager_DiseaseProfile_ProfileTab_Epidemiology,
    Manager_DiseaseProfile_ProfileTab_Prognosis,
    Manager_DiseaseProfile_ProfileTab_References];
export const Manager_DiseaseProfile_MultiVarTab_Description = 'description';
export const Manager_DiseaseProfile_MultiVarTab_Values = 'values';
export const Manager_DiseaseProfile_MultiVarTab_References = 'references';
const Manager_DiseaseProfile_MultiVarTabs = [Manager_DiseaseProfile_MultiVarTab_Description,
    Manager_DiseaseProfile_MultiVarTab_Values,
    Manager_DiseaseProfile_MultiVarTab_References];
//# sourceMappingURL=types.js.map